// 通用排序函数
export function sortByCreatedAt<T>(data: T[], getDate: (item: T) => string | null | undefined = (item: T) => {
  const itemAsRecord = item as Record<string, unknown>;
  return itemAsRecord.createdAt as string | null | undefined;
}): T[] {
  if (!Array.isArray(data)) return [];
  return [...data].sort((a, b) => {
    const dateA = getDate(a) ? new Date(getDate(a)!).getTime() : 0;
    const dateB = getDate(b) ? new Date(getDate(b)!).getTime() : 0;
    return dateB - dateA;
  });
}
